<template>
  <div class="row">
    <div
      style="cursor: pointer;"
      class="col-lg-4 col-md-4"
      v-for="item in data"
      :key="item.PhienDauGia.Id"
      v-on:click="$router.push('/product/detail/' + item.PhienDauGia.Id)"
    >
      <auction-item :data="item" />
    </div>
  </div>
</template>

<script>
import AuctionItem from './AuctionItem.vue';
export default {
  name: 'AuctionList',
  components: { AuctionItem },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/AuctionList.vue